import type { ComponentPropsWithRef, ReactNode } from "react";
import styles from "./ListEditTrigger.module.scss";

type ListEditTriggerProps = Omit<
    ComponentPropsWithRef<"button">,
    "children"
> & {
    /** The column's normal display for the row. */
    display: ReactNode;
    isEmpty: boolean;
    /** Shown instead of `display` when empty, revealed with the row. */
    placeholder: string;
};

/**
 * A list editor's chromeless cell trigger: the value, or its placeholder
 * revealed on the row. Out of the Tab order; the arrow keys reach the cell
 * and Enter opens the editor.
 */
export const ListEditTrigger = ({
    display,
    isEmpty,
    placeholder,
    ref,
    ...buttonProps
}: ListEditTriggerProps) => (
    <button
        type="button"
        {...buttonProps}
        ref={ref}
        tabIndex={-1}
        className={styles.trigger}
        data-dt-list-trigger=""
    >
        {isEmpty ? (
            <span className={styles.add} data-picker-cell-add="">
                {placeholder}
            </span>
        ) : (
            <span className={styles.value}>{display}</span>
        )}
    </button>
);
